import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import styled from '@emotion/styled';
import { ContentItemMeta } from 'app-components/contents/ContentItemMeta';
import React, { useCallback, useMemo } from 'react';
import { Link } from 'ui-components/common/Link';
import { ContentBadgeGroup } from 'ui-components/contents/ContentBadgeGroup';
import { ContentCover } from 'ui-components/contents/ContentCover';
import { IconCountType } from 'ui-components/contents/IconCount';
import { getIconCountMap } from 'utils/content';

interface ExploreContentItemProps {
  content: ContentPublicRelayDto;
  profile?: ProfileLitePublicRelayDto;
  listItemIndex: number;
  onClick?: (index: number, content: ContentPublicRelayDto) => void;
}

export const ExploreContentItem = ({ content, profile, listItemIndex, onClick }: ExploreContentItemProps) => {
  const iconCountMap = useMemo(
    () =>
      getIconCountMap([IconCountType.View, IconCountType.Recommend, IconCountType.Favorite], {
        viewCount: content.counts.viewCount,
        recommendCount: content.counts.recommendCount,
        favoriteCount: content.counts.favoriteCount,
      }),
    [content],
  );

  const handleClick = useCallback(() => {
    onClick?.(listItemIndex, content);
  }, [onClick, listItemIndex, content]);

  return (
    <StyledContainer onClick={handleClick}>
      <Link href={`/contents/${content.id}`}>
        <ContentCover content={content}>
          <ContentBadgeGroup content={content} />
        </ContentCover>
      </Link>
      <StyledMetaContainer>
        <ContentItemMeta
          content={content}
          profile={profile}
          iconCounts={iconCountMap}
          showCategoryType
          showKeyword
          showEpisodeCount
          showDescription
          maxShowKeywordCount={3}
          maxTitleLine={1}
          href={`/contents/${content.id}`}
        />
      </StyledMetaContainer>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

const StyledMetaContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  gap: 4px;
`;
